import React, { useState, useEffect } from 'react';
import Light from './headers/light';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import ProductTabs from "./cards/TabCardGrid2"; // TabCardGrid2 = ProductTabs
import LightAdmin from './headers/lightAdmin';
import { useTranslation } from 'react-i18next';
import Footerr from './footers/Footer';

const Boutique = () => {
  const [role, setRole] = useState('');
  const [cart, setCart] = useState([]);
  const [products, setProducts] = useState([]);
const { i18n } = useTranslation();

  useEffect(() => {
    const userRole = localStorage.getItem('role');
    setRole(userRole);
    const fetchProducts = async () => {
      try {
const res1 = await fetch(`  https://plateformewmg.cloud/api/products?lang=${i18n.language}`);
       const data = await res1.json();
       setProducts(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erreur lors du chargement des produits :", error);
      }
    };

    fetchProducts();
  }, [i18n.language]);
  console.log("boutique",products);
  const handleAddToCart = (product) => {
    const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
    const found = existingCart.find(item => item.productID === product.ProductID);

    if (found) {
      found.quantity += 1;
    } else {
      existingCart.push({
        productID: product.ProductID,
        productName: product.Name,
        productImage: product.image,
        productPrice: role === "supplier" ? product.distributeur_price : product.user_price,
        quantity: 1
      });
    }
    localStorage.setItem('cart', JSON.stringify(existingCart));
    setCart(existingCart);
    alert("Produit ajout� au panier !");
  };

  return (
    <AnimationRevealPage>
      {role === "supplier" ? <Light /> : role === "admin" ? <LightAdmin /> : <Light />}
      <ProductTabs
        heading=""
        products={products}
        role={role}
        onAddToCart={handleAddToCart}
      />
      <Footerr />
    </AnimationRevealPage>
  );
};

export default Boutique;
